import React from 'react';

// 依次产生动画的动画容器
function TakeTurns({children, divide = 500}) {
  return React.Children.map(children, (child, index)=>{
    return React.cloneElement(child, {delay: index * divide})
  })
}

export default TakeTurns;